import { render, staticRenderFns } from "./IconTarget.vue?vue&type=template&id=6c7a73d7&"
import script from "./IconTarget.vue?vue&type=script&lang=js&"
export * from "./IconTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c7a73d7')) {
      api.createRecord('6c7a73d7', component.options)
    } else {
      api.reload('6c7a73d7', component.options)
    }
    module.hot.accept("./IconTarget.vue?vue&type=template&id=6c7a73d7&", function () {
      api.rerender('6c7a73d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTarget.vue"
export default component.exports